let language = {
    ORDERS_TITLE_EMPTY: "样品订单为空。",
    ORDERS_TITLE_TIPS: "没有符合条件的订单，请尝试其他搜索条件。",
    ORDERS_TITLE_INVOICE: "批量下载发票",
    ORDERS_TITLE_OPERATION: "操作",    
    ORDERS_TITLE_NAME: "名称",
    ORDERS_TITLE_TOTAL: "总价",
    ORDERS_TITLE_ORDER_STATUS: "订单状态",
    ORDERS_TITLE_OPTIONS: "选项",
    ORDERS_TITLE_CANCEL: "取消订单",
    ORDERS_TITLE_RETURN: "退货请求",
}

export { language }
